export default {
  "app_label": "estimation",
  "model_name": "bluebeammapping",
  "pagination": true,
  "columns": [
    {
      "name": "pk",
      "label": "ID",
      "help_text": null,
      "hidden": true,
      "identifier": false,
      "data_type": "int",
      "search": false,
      "sort": false
    },
    {
      "name": "subject",
      "label": "Subject",
      "data_type": "str",
      "search": true,
      "sort": true,
    },
    {
      "name": "section",
      "label": "Section",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": null,
      "child_path": "name",
      "search": true,
      "sort": true
    },
    {
      "name": "subsection",
      "label": "Subsection",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": null,
      "child_path": "identifier",
      "search": true,
      "sort": true
    },
    {
      "name": "order",
      "label": "Order",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "int",
      "search": false,
      "sort": true
    },
    {
      "name": "modified",
      "label": "Modified",
      "help_text": null,
      "hidden": false,
      "identifier": false,
      "data_type": "datetime",
      "search": false,
      "sort": false
    }
  ],
  "filter_by": [
    {
      "label": "Section",
      "name": "section",
      "type": "api_reference",
      "api": {
        "url_name": "api:admin:estimation:section:autocomplete",
        "key": "pk",
        "display": "name",
        "pagination": true
      }
    },
    {
      "label": "Subsection",
      "name": "subsection",
      "type": "api_reference",
      relates: ['section'],
      "api": {
        "url_name": "api:admin:estimation:subsection:autocomplete",
        "key": "pk",
        "display": "name",
        "pagination": true
      }
    },
  ],
  "export_import": null
}